import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import Image from 'next/image';
import CarouselControl from '@/assets/icons/carousel-control.svg';
import CONFIG from 'config';
import { toBase64, shimmer } from '@/utils/helpers/shimmer';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HBBusService from 'src/services/hbBusService';
import { formatUrlForHttp } from '@/utils/helpers/urlFormatter';

export type SliderImageType = {
  title?: string;
  targetUrl: string;
  imagePath: string;
  order: string;
  partnerName?: string;
};

export type SizeType = {
  width: number;
  height: number;
};

interface Props {
  images: SliderImageType[];
  size: SizeType;
  location: string;
}

const SliderComponent: React.FC<Props> = ({ images, size, location }) => {
  const hbBus = HBBusService();

  const [slideAction, setSlideAction] = useState<string>(null);
  const [slideIndexes, setSlideIndexes] = useState<{
    oldSlide: number;
    activeSlide: number;
  }>({ oldSlide: null, activeSlide: null });

  const slider: any = useRef();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (location === 'home') {
        const bannerNames: string[] = [];
        const partnerNames: string[] = [];
        images.map((e) => {
          bannerNames.push(e.title);
          partnerNames.push(e.partnerName ? e.partnerName : '');
        });
        hbBus.bannerCountEvent(
          images.length.toString(),
          bannerNames,
          partnerNames
        );
        hbBus.pageLoadEvent('İş Ortağım Ana Sayfa');
      }
    }
  }, []);

  useEffect(() => {
    bannerChangeEventHandler();
  }, [slideIndexes]);

  const bannerChangeEventHandler = () => {
    if (slideAction && location === 'home') {
      hbBus.bannerChangeEvent(
        slideIndexes?.oldSlide + 1,
        slideIndexes?.activeSlide + 1,
        slideAction
      );
    }
    setSlideAction(null);
  };

  const next = () => {
    setSlideAction('right');
    slider.current.slickNext();
  };
  const previous = () => {
    setSlideAction('left');
    slider.current.slickPrev();
  };

  const bannerClickHandler = (index: number, banner: any) => {
    if (location === 'home') {
      hbBus.bannerClickEvent(
        index + 1,
        banner.title,
        banner.targetUrl,
        banner?.startDate,
        banner?.endDate ? banner?.endDate : '',
        banner?.partnerName ? banner?.partnerName : ''
      );
    }
  };

  const settings_3 = {
    dots: location === 'home' ? false : true,
    infinite: true,
    speed: 500,
    lazyLoad: 'ondemand' as 'ondemand' | 'progressive',
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,

    adaptiveHeight: true,
    arrows: false,
    // afterChange: changeEvent,
    draggable: false,
    swipeToSlide: false,
    touchMove: false,
    swipe: false,
    beforeChange: (current: number, next: number) =>
      setSlideIndexes({ oldSlide: current, activeSlide: next }),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
        },
      },
    ],
  };

  const onClickHomeBanner = (i: any, e: any) => {
    bannerClickHandler(i, e);
    //@ts-ignore
    if (typeof window.MerchantMobileApi !== 'undefined') {
      let formattedUrl = formatUrlForHttp(e.targetUrl);
      if (!formattedUrl.includes('http')) {
        formattedUrl = 'https:' + formattedUrl;
      }
      //@ts-ignore
      window.MerchantMobileApi.openExternalLink(formattedUrl);
    }
  };
  return (
    <div className={'relative '}>
      {images.length > 1 ? (
        <>
          <a
            className={
              'absolute z-10 top-[25%] lg:top-[40%] left-[20px]  cursor-pointer'
            }
            onClick={previous}
          >
            <Image
              src={CarouselControl}
              alt='CarouselControl'
              width={48}
              height={48}
              className={'rotate-180 opacity-60'}
            />
          </a>
          <a
            className={
              'absolute z-10 top-[25%] lg:top-[40%] right-[20px] cursor-pointer'
            }
            onClick={next}
          >
            <Image
              src={CarouselControl}
              alt='CarouselControl'
              width={48}
              height={48}
              className='opacity-60'
            />
          </a>
        </>
      ) : null}

      <Slider ref={(c) => (slider.current = c)} {...settings_3}>
        {images.map((e: any, i) => {
          if (!e.imagePath.includes(' ')) {
            return (
              <>
                <div key={i}>
                  {!e.targetUrl ? (
                    <Image
                      src={CONFIG.ENDPOINTS.imageBasePath + e.imagePath}
                      width={size.width}
                      height={size.height}
                      objectFit='cover'
                      layout='responsive'
                      alt='slide'
                      placeholder='blur'
                      blurDataURL={`data:image/svg+xml;base64,${toBase64(
                        shimmer(700, 475)
                      )}`}
                      quality={100}
                      priority
                      className='ease-in duration-300'
                    />
                  ) : (
                    <a
                      href={
                        //@ts-ignore
                        typeof window.MerchantMobileApi === 'undefined' &&
                        formatUrlForHttp(e.targetUrl)
                      }
                      target='_blank'
                      rel='noreferrer'
                      onClick={() => onClickHomeBanner(i, e)}
                    >
                      <Image
                        src={CONFIG.ENDPOINTS.imageBasePath + e.imagePath}
                        width={size.width}
                        height={size.height}
                        objectFit='cover'
                        layout='responsive'
                        alt='slide'
                        placeholder='blur'
                        blurDataURL={`data:image/svg+xml;base64,${toBase64(
                          shimmer(700, 475)
                        )}`}
                        quality={100}
                        priority
                        className='ease-in duration-300'
                      />
                    </a>
                  )}
                </div>
                {e.title ? (
                  <div className='flex justify-center md:justify-start bg-white p-6 text-[18px] md:text-[24px] font-semibold text-[#212121] rounded-b-lg border-x-2 border-b-2'>
                    {e.title}
                  </div>
                ) : null}
              </>
            );
          }
        })}
      </Slider>
    </div>
  );
};

export default SliderComponent;
